const outputs = {
  outputs: 'Salidas',
  table: {
    displayName: 'Nombre',
    serialNumber: 'Serial',
    searchPlaceHolder: 'Nombre / Serial',
    enabled: 'Habilitado',
  },
  modal: {
    title: 'Propiedades',
    tabInformation: 'Informacion General',
    TabEvents: 'Eventos',
  },
  form: {
    checkEnable: 'Activar',
    radioNormallyOpen: 'Normalmente abierto',
    radioNormallyClose: 'Normalmente cerrado',
  },
};

export default outputs;
